import { signIn, useSession } from 'next-auth/react';
import { usePathname } from 'next/navigation';
import { useEffect } from 'react';

const TAB_REDIRECT_KEY = 'auth_redirect_started_in_this_tab';

export function AuthSessionWatcher() {
  const { data: session, status } = useSession();
  const pathname = usePathname();

  useEffect(() => {
    if (status !== 'authenticated') return;
    if ((session as any)?.error !== 'RefreshAccessTokenError') return;
    if (document.visibilityState !== 'visible') return;
    if (sessionStorage.getItem(TAB_REDIRECT_KEY)) return;
    if (pathname === '/open-login') return;

    const startSignIn = async () => {
      sessionStorage.setItem(TAB_REDIRECT_KEY, 'true');

      await signIn((session as any)?.provider || 'aad', {
        callbackUrl: window.location.href || '/',
      });
    };

    if ('locks' in navigator) {
      navigator.locks.request('nextauth-refresh-redirect', { ifAvailable: true }, async (lock) => {
        if (!lock) return;
        await startSignIn();
      });

      return;
    }

    // Fallback for browsers without Web Locks API.
    const lockKey = 'auth_redirect_in_progress';
    const now = Date.now();
    const existingLock = Number(localStorage.getItem(lockKey) || 0);

    if (existingLock && now - existingLock < 60_000) return;

    localStorage.setItem(lockKey, String(now));
    startSignIn();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [session, status]);

  return null;
}
